import { render, staticRenderFns } from "./baformu.vue?vue&type=template&id=7602ab02&"
import script from "./baformu.vue?vue&type=script&lang=js&"
export * from "./baformu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports